import { render } from "./resumePenilaian.vue?vue&type=template&id=9fb9ca0e"
import script from "./resumePenilaian.vue?vue&type=script&lang=js"
export * from "./resumePenilaian.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__